import React from "react";

const NoticeInfo = ({ notice }) => {
  return (
    <>
      <div className="notice-item border-bottom p-3">
        <span className={`badge bg-danger rounded-pill mb-2`}>{notice.tag}</span>
        <p className="mb-1 fw-bold">{notice.name}</p>
        <p
          className="small text-muted mb-0"
          dangerouslySetInnerHTML={{
            __html: notice.description,
          }}
        />
      </div>
    </>
  );
};

export default NoticeInfo;
